import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuditChannelService
{
  constructor(private http: HttpClient) { }

  /**
   * Get audit channels details
   *
   * @param channelId Channel Id
   * @param revisionId Revision Id
   */
  public getAuditChannelDetails(detailTypeUrl: string, channelId: number, revisionId: number, revisionType: number): Observable<any>
  {
    return this.http.get<any>(`/audit/${detailTypeUrl}/details/${channelId}/${revisionId}/${revisionType}`);
  }
}